import { InjectionToken } from '@angular/core';

export const EDIT_MODE = new InjectionToken<boolean>('Edit Mode');
